import { useCallback, useEffect, useState } from "react";
import { notificationsAPI, type FeatureFlags } from "@/api/notifications";
import { useAuth } from "@/shared/contexts/AuthContext";

export function useNotificationsFeatureFlag() {
	const { isAuthenticated } = useAuth();
	const [flags, setFlags] = useState<FeatureFlags>({ notificationsEnabled: false });
	const [loading, setLoading] = useState(true);

	const refresh = useCallback(async () => {
		if (!isAuthenticated) {
			setFlags({ notificationsEnabled: false });
			setLoading(false);
			return;
		}
		try {
			const next = await notificationsAPI.getFeatureFlags();
			setFlags(next);
		} catch (error) {
			console.error("Failed to load notification feature flags", error);
			setFlags({ notificationsEnabled: false });
		} finally {
			setLoading(false);
		}
	}, [isAuthenticated]);

	useEffect(() => {
		void refresh();
	}, [refresh]);

	return {
		notificationsEnabled: flags.notificationsEnabled,
		loading,
		refresh,
	};
}
